export const USER_PREFERENCES = 'user_preferences';

export const STORE_KEYS = {
  USER_PREFERENCES
};
